import React, { FC } from 'react';
import { CustomTooltip } from '@components/CustomTooltip';
import { CustomTooltipProps } from '@components/CustomTooltip/CustomTooltip';
import { Chip, ChipProps } from '@mui/material';

type Props = {
  label: string;
  tooltip?: Partial<Omit<CustomTooltipProps, 'children'>>;
  chip?: ChipProps;
};

const ChipWithTooltip: FC<Props> = ({ label, tooltip, chip }) => {
  return (
    <CustomTooltip placement="left" title={label} {...tooltip}>
      <Chip
        label={label}
        size="small"
        variant="grey"
        sx={{ cursor: 'pointer' }}
        {...chip}
      />
    </CustomTooltip>
  );
};

export default ChipWithTooltip;
